var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"biaoti"},[_vm._v("分类管理")]),_c('Fenlei',{model:{value:(_vm.shu),callback:function ($$v) {_vm.shu=$$v},expression:"shu"}}),_c('Tijiao',{staticClass:"p_adding",attrs:{"wenzi":"保存"},on:{"click":_vm.Tijiao}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }